// src/oura/components/newscan/SectionHead.tsx
//
// A section's head on the Review (Jack, 20 Oct: "the issues below also has no
// header, its just very confusing what is what"): a card-title-sized name, an
// optional count, and one line on what to do there.

import type { ReactNode } from "react";
import { cn } from "@oura/lib/cn";
import { TYPE } from "@oura/ui";

export function SectionHead({ id, title, count, sub }: { id?: string; title: string; count?: number; sub?: ReactNode }) {
    return (
        <div>
            <h2 id={id} className={cn(TYPE.tt, "m-0 flex items-baseline gap-2 text-gray-900")}>
                {title}
                {count !== undefined && <span className="font-normal tabular-nums text-gray-400">{count}</span>}
            </h2>
            {sub && <div className={cn(TYPE.tc, "m-0 mt-0.5 text-gray-500")}>{sub}</div>}
        </div>
    );
}
